import { propOr } from "ramda";
import { LayoutRow } from './building-layout.types';

export type PropOrValue<T> = T | {value:T}

export const formikFieldOrValue = <T>(obj: PropOrValue<T>):T => propOr(obj,"value",obj)

export const hasRooms = (row: PropOrValue<LayoutRow>) => {
  const value = formikFieldOrValue<LayoutRow>(row);
  return value.rooms.length > 0;
}

export const hasNoRooms = (row: PropOrValue<LayoutRow>) => {
  const value = formikFieldOrValue<LayoutRow>(row);
  return value.rooms.length === 0;
}

export const haveDifferentLengths = (rowFst: PropOrValue<LayoutRow>, rowSnd: PropOrValue<LayoutRow>) => {
  return formikFieldOrValue<LayoutRow>(rowFst).rooms?.length === formikFieldOrValue<LayoutRow>(rowSnd).rooms?.length;
}
